"use strict";

require("core-js/modules/esnext.promise.all-settled.js");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.identifyUserBy = exports.trackEvent = exports.trackEventPromise = exports.initializeTracking = void 0;

var browser_tracker_1 = require("@snowplow/browser-tracker");

var constants_1 = require("./constants");

var utils_1 = require("./utils");

var initializeTracking = function initializeTracking(locale, enableExponea, appId) {
  if (enableExponea === void 0) {
    enableExponea = true;
  }

  window.sessionStorage.removeItem(constants_1.IDENTIFIED_USER_SESSION_NAME);
  (0, utils_1.initSnowplow)(appId);

  if (enableExponea) {
    (0, utils_1.initExponea)(locale);
  }
};

exports.initializeTracking = initializeTracking;

var trackEventPromise = function trackEventPromise(_a, trackToExponea, trackToSnowplow) {
  var schema = _a.schema,
      trackingProperties = __rest(_a, ["schema"]);

  if (trackToExponea === void 0) {
    trackToExponea = false;
  }

  if (trackToSnowplow === void 0) {
    trackToSnowplow = true;
  }

  var trackingData = mapTrackingData(trackingProperties);
  var promises = [];

  if (trackToExponea) {
    promises.push(trackEventToExponea({
      trackingData: trackingData
    }));
  }

  if (trackToSnowplow) {
    promises.push(trackEventToSnowplow({
      trackingData: trackingData,
      schema: schema
    }));
  }

  return Promise.allSettled(promises);
};

exports.trackEventPromise = trackEventPromise;

var trackEvent = function trackEvent(_a, trackToExponea, trackToSnowplow) {
  var schema = _a.schema,
      trackingProperties = __rest(_a, ["schema"]);

  if (trackToExponea === void 0) {
    trackToExponea = false;
  }

  if (trackToSnowplow === void 0) {
    trackToSnowplow = true;
  }

  var trackingData = mapTrackingData(trackingProperties);

  if (trackToExponea) {
    trackEventToExponea({
      trackingData: trackingData
    });
  }

  if (trackToSnowplow) {
    trackEventToSnowplow({
      trackingData: trackingData,
      schema: schema
    });
  }
};

exports.trackEvent = trackEvent;

var mapTrackingData = function mapTrackingData(_a) {
  var eventName = _a.eventName,
      object = _a.object,
      action = _a.action,
      portal = _a.portal,
      description = _a.description,
      boundedContext = _a.boundedContext,
      zone = _a.zone,
      bipsDomain = _a.bipsDomain,
      context = _a.context,
      component = _a.component,
      productId = _a.productId,
      customerGroup = _a.customerGroup,
      customAttribute1 = _a.customAttribute1,
      customAttribute2 = _a.customAttribute2,
      customAttribute3 = _a.customAttribute3,
      customAttribute4 = _a.customAttribute4,
      customAttribute5 = _a.customAttribute5,
      customAttribute6 = _a.customAttribute6,
      customAttribute7 = _a.customAttribute7,
      customAttribute8 = _a.customAttribute8,
      customAttribute9 = _a.customAttribute9,
      customAttribute10 = _a.customAttribute10,
      countryPlatform = _a.countryPlatform;
  return {
    event_name: eventName,
    object: object,
    action: action,
    portal: portal,
    description: description,
    bounded_context: boundedContext,
    zone: zone,
    context: context,
    component: component,
    product_id: productId,
    bips_domain: bipsDomain,
    browsing_platform: (0, utils_1.getBrowsingApp)(),
    country_platform: countryPlatform || (0, utils_1.getCountryPlatform)(),
    customer_group: customerGroup,
    custom_attribute_1: customAttribute1,
    custom_attribute_2: customAttribute2,
    custom_attribute_3: customAttribute3,
    custom_attribute_4: customAttribute4,
    custom_attribute_5: customAttribute5,
    custom_attribute_6: customAttribute6,
    custom_attribute_7: customAttribute7,
    custom_attribute_8: customAttribute8,
    custom_attribute_9: customAttribute9,
    custom_attribute_10: customAttribute10
  };
};

var trackEventToSnowplow = function trackEventToSnowplow(_a) {
  var schema = _a.schema,
      trackingData = _a.trackingData;
  return new Promise(function (resolve) {
    var isLoggedIn = (0, utils_1.hasCookieForSession)();
    var event = {
      event: {
        schema: schema || constants_1.SNOWPLOW.SCHEMA,
        data: trackingData
      }
    };

    if (isLoggedIn) {
      var counter_1 = 0;
      var interval_1 = setInterval(function () {
        var isUserIdentified = !!window.sessionStorage.getItem(constants_1.IDENTIFIED_USER_SESSION_NAME);

        if (isUserIdentified) {
          (0, browser_tracker_1.trackSelfDescribingEvent)(event);
          clearInterval(interval_1);
          resolve();
        }

        if (++counter_1 > 10) {
          clearInterval(interval_1);
          resolve();
        }
      }, 300);
    } else {
      (0, browser_tracker_1.trackSelfDescribingEvent)(event);
      resolve();
    }
  });
};

var trackEventToExponea = function trackEventToExponea(_a) {
  var trackingData = _a.trackingData;
  return new Promise(function (resolve) {
    var successCallback = function successCallback() {
      resolve();
    };

    var errorCallback = function errorCallback() {
      resolve();
    };

    var exponeaObject = window === null || window === void 0 ? void 0 : window['exponea'];

    if (exponeaObject === null || exponeaObject === void 0 ? void 0 : exponeaObject.isInitialized) {
      exponeaObject.track(trackingData.event_name.toLowerCase(), trackingData, successCallback, errorCallback);
      return;
    }

    resolve();
  });
};

var identifyUserBy = function identifyUserBy(type, value) {
  var _a;

  var exponeaObject = window === null || window === void 0 ? void 0 : window['exponea'];

  if (exponeaObject === null || exponeaObject === void 0 ? void 0 : exponeaObject.isInitialized) {
    exponeaObject.identify((_a = {}, _a[type] = value, _a));
  }

  browser_tracker_1.setUserId === null || browser_tracker_1.setUserId === void 0 ? void 0 : (0, browser_tracker_1.setUserId)(value);
  window.sessionStorage.setItem(constants_1.IDENTIFIED_USER_SESSION_NAME, 'true');
};

exports.identifyUserBy = identifyUserBy;